import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { CartItem } from './CartItem'

// Each photo book ships as its own order so the order's draft records that one
// book; every other product type ships as one order carrying all its items.
export function getCartItemOrderKey(item: CartItem): string {
  if (item.productType === PRODUCT_TYPES.PHOTO_BOOK) {
    return `${PRODUCT_TYPES.PHOTO_BOOK}:${item.id}`
  }
  return item.productType
}

export function getOrderIndexByCartItemId(
  cartItems: CartItem[]
): Map<string, number> {
  const orderIndexByOrderKey = new Map<string, number>()
  const orderIndexByCartItemId = new Map<string, number>()

  for (const item of cartItems) {
    const orderKey = getCartItemOrderKey(item)
    const knownOrderIndex = orderIndexByOrderKey.get(orderKey)
    const orderIndex = knownOrderIndex ?? orderIndexByOrderKey.size
    if (knownOrderIndex === undefined) {
      orderIndexByOrderKey.set(orderKey, orderIndex)
    }
    orderIndexByCartItemId.set(item.id, orderIndex)
  }

  return orderIndexByCartItemId
}
